<template>
  <div class="base-layout">
    <dx-header @toggle-menu="toggleMenu"></dx-header>
    <dx-mobile-nav :active="activeMenu"></dx-mobile-nav>
    <dx-notification />
    <slot></slot>
  </div>
</template>

<script>
import {
  DxHeader,
  DxMobileNav,
  DxNotification
} from '../components'
export default {
  name: 'new-game',
  components: {
    DxHeader,
    DxMobileNav,
    DxNotification
  },
  data () {
    return {
      activeMenu: false
    }
  },
  methods: {
    toggleMenu () {
      this.activeMenu = !this.activeMenu
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/BaseLayout.vue